import { useFeaturePermissions } from '../Selectors/Permission';
import type { FeaturePermissions } from './types';

// Define const to lessen typo's
export const READ = 'READ';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const ENTITY_TYPE_UI = 'UI';
export const ENTITY_TYPE_DONOR = 'Donor';
export const ENTITY_TYPE_CHATROOM = 'Chatroom';
export const ENTITY_TYPE_OFFER = 'Offer';
export const ENTITY_TYPE_TEAM = 'Team';
export const ENTITY_TYPE_EXTERNAL = 'ExternalUser';
export const SUB_ENTITY_TYPE_MANAGER = 'Manager';
export const SUB_ENTITY_TYPE_TRACKER = 'Tracker';
export const SUB_ENTITY_TYPE_TRACKER_ACKS = 'TrackerAcks';
export const SUB_ENTITY_TYPE_TRACKER_PEOPLE = 'TrackerPeople';
export const SUB_ENTITY_TYPE_DETAILS = 'Details';
export const SUB_ENTITY_TYPE_TIMELINE = 'Timeline';
export const SUB_ENTITY_TYPE_FILES = 'Files';
export const SUB_ENTITY_TYPE_TASK = 'Task';
export const SUB_ENTITY_TYPE_DONOR_PERMISSIONS = 'Permissions';
export const NONE = undefined;
export const ANY = 'ANY'; // Designates permission to subEntity of any subEntityId

// Apply any client-side default feature permissions on top of the resolved set.
// Likely this will be for Basic Users as Orgs can use ClientPermissions; the
// Admin Portal has no way to add BasicUser permissions yet.
export const applyDefaultFeaturePermissions = (
  accessLevel: string,
  featurePermissions: FeaturePermissions,
): FeaturePermissions => {
  if (accessLevel === 'BasicUser') {
    return { ...featurePermissions, demoCase: true };
  }
  return featurePermissions;
};

export function useCanUseUnosApi() {
  const featurePermissions = useFeaturePermissions();
  return featurePermissions.unosApi;
}
